import React from "react"
import { Container } from "react-bootstrap"

const HeaderBanner = ({ data }) => {
  const { field_heading, relationships } = data

  const { field_image, field_banner } = relationships
  //console.log(field_image.relationships.field_media_image.localFile.publicURL )

  return (
    <section class="section__header_banner">
      <div className="bg-wrapper d-flex align-items-end">
        <div className="header_banner-image">
          <img
            src={
              field_banner[0].relationships.field_media_image.localFile
                .childImageSharp.original.src
            }
            className="img-fluid d-none d-sm-flex"
            alt=""
          />

          <img
            src={
              field_banner[1].relationships.field_media_image.localFile
                .childImageSharp.original.src
            }
            className="img-fluid d-sm-none"
            alt=""
          />
        </div>
        <Container>
          <div className="d-flex flex-column flex-md-row align-items-md-center header_banner-text justify-content-between">
            <div className="title">
              <div className="title__sm">Study Melbourne</div>
              {field_heading}
            </div>

            <div className="logo">
              <img
                src={
                  field_image.relationships.field_media_image.localFile
                    .childImageSharp.original.src
                }
                alt=""
              />
            </div>
          </div>
        </Container>
      </div>
    </section>
  )
}

export default HeaderBanner
